import React from 'react';
import { Tabs, Input, DatePicker, Button, Space } from 'antd';

const { Search } = Input;
const { RangePicker } = DatePicker;

const ReportsSearchBar = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow mt-4">
      <Tabs defaultActiveKey="1" centered>
        <Tabs.TabPane tab="Production Reports" key="1" />
        <Tabs.TabPane tab="OEE Reports" key="2" />
        <Tabs.TabPane tab="Downtime Reports" key="3" />
      </Tabs>

      <div className="flex justify-between items-center mt-4">
        <Search
          placeholder="Search"
          onSearch={(value) => console.log(value)}
          style={{ width: 200 }}
        />
        
        <Space>
          <RangePicker />
          <Button icon={<i className="fas fa-filter"></i>}>Filter</Button>
        </Space>
      </div>

      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center space-x-2">
          <span>Actual Target</span>
          <div className="flex items-center space-x-1">
            <span className="w-4 h-4 bg-green-400 inline-block rounded-full"></span>
            <span>100%</span>
          </div>
          <div className="flex items-center space-x-1">
            <span className="w-4 h-4 bg-yellow-400 inline-block rounded-full"></span>
            <span>70% to 99%</span>
          </div>
          <div className="flex items-center space-x-1">
            <span className="w-4 h-4 bg-red-400 inline-block rounded-full"></span>
            <span>Below 70%</span>
          </div>
        </div>

        <div className="flex space-x-2">
          <Button type="primary">Download</Button>
          <Button>Graph Reports</Button>
          <Button>Detail Reports</Button>
        </div>
      </div>
    </div>
  );
};

export default ReportsSearchBar;
